import { useChat } from "../contexts/ChatContext";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";
import { ReactComponent as IconCloseSquare } from "../../../images/cancel.svg";

import { Button, Modal } from "cai-fusion";
import env from "../../../configs/envConfig";

const ExportChatModal = () => {
	const { exportChat } = useChat();
	const { visibilityStates, hide } = useTransientVisibility();

	return (
		<Modal
			id="export-modal"
			isHidden={ !visibilityStates.ExportChatModal }
			clickOutsideToClose={ true }
			title="Export Chat"
			onClose={(e) => {
				hide('ExportChatModal')
				e.preventDefault();
			}}
			actions={
				<>
					<Button
						outline
						onClick={(e) => {
							e.preventDefault();
							hide('ExportChatModal');
						}}
						children="Cancel"
					/>
					<Button
						onClick={(e) => {
							e.preventDefault();
							exportChat();
							hide('ExportChatModal');
						}}
						children="Export Chat"
					/>
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
					<p>
						Download this chat as a PDF so that you can archive,
						share it, or even include it in other {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} chats.
					</p>
					{/* <form action="" class="o-form l-mt-sm">
						<label class="a-radio-btn">
							<span class="a-radio-btn__label">
								Include the chat's audit trail
							</span>
							<input type="radio" checked name="share-type" />
							<div class="b-input"></div>
						</label>
						<label class="a-radio-btn l-mt-xs">
							<span class="a-radio-btn__label">
								Don't include audit trail
							</span>
							<input type="radio" name="share-type" />
							<div class="b-input"></div>
						</label>
					</form> */}
				</div>
			</div>
		</Modal>
	);
};

export default ExportChatModal;
